import ApprovalsComponent from "./ApprovalsComponent";
import { useContext } from "react";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";
import UpdateCompanyDetailsContext from "context/UpdateCompanyDetails";

const Approvals = ({ handleGoBack, handleGoForward }) => {
  const { transactions } = useContext(UpdateCompanyDetailsContext);

  if (transactions.length > 0) {
    return (
      <ApprovalsComponent
        approvalComponentsCallBack={() => null}
        transactions={transactions}
        handleGoBack={handleGoBack}
        handleGoForward={handleGoForward}
      />
    );
  } else {
    return (
      <div className="flex justify-center p-5 bg-white w-full h-40">
        <SpinnerIcon />
      </div>
    );
  }
};

export default Approvals;
